<style scoped>
    .naked-btn-styles .btn.dropdown-toggle:focus {
        border: 0 !important;
        box-shadow: none !important;
    }
    .naked-btn-styles {
        vertical-align: bottom !important;
    }
    .naked-btn-styles .btn {
        min-height: 24px !important;
        max-height: 24px !important;
    }
    .naked-btn-styles .btn.dropdown-toggle {
        color: #fff !important;
        border: 0 !important;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }
    .naked-btn-styles .funnel-reset {
        border: 0 !important;
        padding: 0.175rem 0.2rem !important;
    }
    .dropdown-menu {
        min-width: 2rem !important;
    }
    th .btn-group {
        display: inline-flex;
    }
    th .btn-group .btn {
        font-weight: bold;
        text-transform: capitalize;
        font-family: "proxima-soft","Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol" !important;
    }
</style>
<template>
    <div class="btn-group" :class="classes">
        <button :class="btn_classes ? 'btn dropdown-toggle '+btn_classes : 'btn dropdown-toggle'" type="button" :id="'dropdownfilter'+keyName" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
            <slot></slot> <span class="caret"></span>
        </button>
        <div class="dropdown-menu dropdown-filter" :aria-labelledby="'dropdownfilter' + keyName">
            <div>
                <button type="button" :class="{'btn btn-light btn-block border-0 py-0 my-1': true, 'btn-success': selected.indexOf(itm) >= 0}" v-for="itm in univers" @click="toggle(itm, $event)" style="text-align: left"><span v-if="selected.indexOf(itm) >= 0" class="glyphicon glyphicon-ok"></span><span v-else> </span> {{itm}}</button>
            </div>
        </div>
        <button v-if="selected.length" class="funnel-reset btn btn-sm" @click="reset"><i class="glyphicon glyphicon-filter fa fas fa-filter"></i><span class="glyphicon glyphicon-remove fa fas fa-times text-danger"></span></button>
    </div>
</template>


<script>
import _ from 'lodash'

export default {
  props: {
    list: Array,
    keyName: String,
    competitors: {
      type: Array,
      default: []
    },
    classes: String,
    btn_classes: String,
    valMap: Object
  },
  data: function () {
    return {
      keySet: [],
      unranked: false,
      selected: []
    }
  },
  methods: {
    toggle: function (itm, ev) {
      var self = this
      var idx = self.selected.indexOf(itm)
      if (idx >= 0) {
        self.selected.splice(idx, 1)
      } else {
        self.selected.push(itm)
      }
      self.$emit('filtered', self)
      ev.target.parentNode.parentNode.scrollTo(0, 0)
    },
    reset: function () {
      this.selected = []
      this.$emit('filtered', this)
    },
    compar: function (a, b) {
      var self = this
      if (self.selected.indexOf(a) >= 0) {
        return -1
      } else {
        if (self.selected.indexOf(b) >= 0) {
          return 1
        } else {
          if (a > b) {
            return 1
          } else {
            if (a < b) {
              return -1
            } else {
              return 0
            }
          }
        }
      }
    }
  },
  computed: {
    univers: function () {
      var self = this
      if (self.keySet.length) {
        return self.keySet.sort(self.compar)
      } else {
        return []
      }
    }
  },
  mounted: function () {
    var self = this
    var listKeys = self.list.length ? Object.keys(self.list[0]) : []
    var keySet = []
    if (listKeys.indexOf(self.keyName) >= 0) {
      keySet = _.map(self.list, function (l) {
        var val = l[self.keyName] !== '' ? l[self.keyName] : '<blank>'
        if (self.valMap) {
          if (self.valMap[l[self.keyName]]) {
            val = self.valMap[l[self.keyName]]
          }
        }
        return val
      })
    } else if (self.keyName.includes('.')) {
      var nestedObjKeys = self.keyName.split('.')
      keySet = _.map(self.list, function (l) {
        var nestedObjs = []
        var val = null

        for (var key of nestedObjKeys) {
          var i = nestedObjKeys.indexOf(key)
          if (i === 0) {
            nestedObjs.push(l[key])
          } else if (nestedObjKeys.length - 1 === i) {
            // final key and value
            console.log(nestedObjs, i)
            val = nestedObjs[(i - 1)][key]
          } else {
            nestedObjs.push(nestedObjs[i][key])
          }
        }
        return val
      })
    } else if (self.competitors.length) {
      keySet = _.map(self.competitors, function (uc) { return uc[self.keyName] })
    }
    self.keySet = _.uniq(keySet) // .sort(self.compare)

    // console.log(this.$parent.filterMapping)

    // check for any default values set
    if (Object.keys(this.$parent.filterMapping).length) {
      console.log(this.$parent.filterMapping[this.keyName])
      this.selected = this.$parent.filterMapping[this.keyName]
    }
  }
}
</script>


// WEBPACK FOOTER //
// Funnel.vue?c89068d2